import { useMemo } from 'react';
import { useAnalyticsStore } from '../analytics.store.js';
import { useRunOnce } from '@fabric-app/hooks/useRunOnce';

const useAnalytics = () => {
  const { track } = useAnalyticsStore();
  return useMemo(() => {
    return {
      /**
      * Tracks an analytics event.
      *
      * @param event - The analytics event to track.
      * @param properties - Optional properties associated with the event.
      */
      track: (event, properties) => track(event, properties)
    };
  }, [
    track
  ]);
};
const useAnalyticsTrackOnceOnMount = (event, properties) => {
  const { track } = useAnalytics();
  useRunOnce(() => {
    track(event, properties);
  });
};

export { useAnalytics, useAnalyticsTrackOnceOnMount };
//# sourceMappingURL=useAnalytics.js.map
